module.exports = __webpack_public_path__ + "img/diagnosis_b.9f271fd8.png";